const bag_related_containers = document.querySelectorAll(
  ".bag-related-container"
);

bag_related_containers.forEach((container) => {
  const bag = container.querySelector(".icon-bag-related");
  const sizes_popup = container.querySelector(".sizes-popup");
  const sizes_popup_close = container.querySelector(
    ".sizes-popup .header-close"
  );
  const cart_popup_closes = container.querySelectorAll(
    ".cart-popup .header-close"
  );
  const sizes = container.querySelectorAll(".sizes li");
  const added_popup = container.querySelector(".cart-popup");
  const no_added_popup = container.querySelector(".cart-popup.no-added");
  const popup_buttons = container.querySelector(".cart-popup .popup-button");
  const main = document.querySelector("main#content");
  const cart_view_button = document.querySelector(".cart-view");

  const product_size = container.querySelector(
    ".cart-popup .product-size span"
  );
  const product_size_container = container.querySelector(
    ".cart-popup .product-size"
  );
  const product_style_container = container.querySelector(
    ".cart-popup .product-style"
  );
  const product_style = container.querySelector(
    ".cart-popup .product-style span"
  );

  if (sizes_popup) {
    bag.addEventListener("click", (event) => {
      if (window.innerWidth <= 768) {
        event.stopPropagation();
      }
      openSizes();
    });

    // Close the popup when clicking outside of it
    document.addEventListener("click", (event) => {
      if (window.innerWidth > 768) {
        const isClickInside = container.contains(event.target);
        if (!isClickInside) {
          closeSizes();
        }
      }
    });

    sizes_popup_close.addEventListener("click", () => {
      closeSizes();
    });

    sizes.forEach((size) => {
      size.addEventListener("click", async () => {
        const variant = size.dataset.variant;
        const options = size.dataset.options;

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variant,
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          console.error("Failed to add item to cart");
          openPopupNo();
          closeSizes();
          return;
        }
        showPopup(options);
        closeSizes();
      });
    });

    container.addEventListener("click", (e) => {
      // e.stopPropagation();
      if (e.target == container) {
        closeSizes();
      }
    });
  } else {
    bag.addEventListener("click", async (event) => {
      if (window.innerWidth <= 768) {
        event.stopPropagation();
      }
      const variant = bag.dataset.variant;
      // console.log("🚀 ~ bag.addEventListener ~ variant:", variant);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variant,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        console.error("Failed to add item to cart");
        openPopupNo();
        return;
      }
      showPopup(null);
    });
  }

  cart_view_button.addEventListener("click", () => {
    closePopup();
  });

  no_added_popup.addEventListener("click", () => {
    closePopup();
  });

  cart_popup_closes.forEach((element) => {
    element.addEventListener("click", () => {
      closePopup();
    });
  });

  popup_buttons.addEventListener("click", () => {
    closePopup();
  });

  added_popup.addEventListener("click", (e) => {
    e.stopPropagation();
    if (e.target == added_popup) {
      closePopup();
    }
  });

  const splitStyleSize = (input) => {
    const parts = input.split("-");
    if (parts.length === 2) {
      return { style: parts[0], size: parts[1] };
    } else {
      return { style: null, size: parts[0] };
    }
  };

  // Examples:
  // console.log(splitStyleSize("Full-S")); // { style: "Full", size: "S" }
  // console.log(splitStyleSize("S")); // { style: null, size: "S" }

  const showPopup = (options) => {
    if (options) {
      const { style, size } = splitStyleSize(options);

      if (style) {
        product_style_container.classList.add("visible");
        product_style.textContent = style;
      }
      product_size.textContent = size;
    } else {
      product_size_container.classList.add("hidden");
    }

    openPopup();
  };

  const closePopup = () => {
    added_popup.classList.remove("popup-active");
    no_added_popup.classList.remove("popup-active");
    main.classList.remove("popup-active");
    document.body.classList.remove("popup-active");
    // console.log("🚀 ~ closePopup ~ closePopup:");
    document.dispatchEvent(
      new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true })
    );
    document.dispatchEvent(
      new CustomEvent("on:cart:change", { bubbles: true, cancelable: false })
    );
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
  };

  const openPopup = () => {
    document.body.classList.add("popup-active");
    main.classList.add("popup-active");
    container.classList.add("popup-active");
    added_popup.classList.add("popup-active");
    // console.log("🚀 ~ openPopup ~ openPopup:");
  };

  const openPopupNo = () => {
    main.classList.add("popup-active");
    document.body.classList.add("popup-active");
    container.classList.add("popup-active");
    no_added_popup.classList.add("popup-active");
    // console.log("🚀 ~ openPopupNo ~ openPopupNo:");
  };

  const closeSizes = () => {
    // console.log("🚀 ~ closeSizes ~ closeSizes:");
    sizes_popup.classList.remove("active");
    container.classList.remove("size-active");
    document.body.classList.remove("size-active");
  };

  const openSizes = () => {
    // console.log("🚀 ~ openSizes ~ openSizes:");

    document.body.classList.add("size-active");
    container.classList.add("size-active");
    sizes_popup.classList.add("active");
  };

  // image_cont.addEventListener("mouseover", (event) => {
  //   // console.log("🚀 ~ event.target:", event.target);
  //   const images_cont = container.querySelectorAll(".image-cont");
  //   event.stopPropagation();

  //   images_cont.forEach((element) => {
  //     if (event.target !== element) {
  //       console.log("not element");
  //     } else {
  //       console.log("element");
  //     }
  //   });
  // });

  // image_cont.addEventListener("mouseover", (event) => {
  //   // console.log("🚀 ~ Hover ~ event:", event);
  //   event.stopPropagation();
  // });
});
